// Icone padrao de editar do sistema (emseg-icones-sistema/icons/editar.svg).
export default function IconEditar({ size = 16, style, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      role="img" aria-label="Editar" style={{ display: 'block', ...style }} {...props}>
      <path d="M4 20l4.2-1 10.6-10.6a2.1 2.1 0 0 0-3-3L5.2 16 4 20zM14.5 6.7l2.8 2.8" />
    </svg>
  )
}
